import styled, { withTheme } from 'styled-components';
import bp from '@bootstrap-styled/css-mixins/lib/breakpoints';

const Style = styled.div`
    background: ${(props) => props.theme.$white};
    .tool-nav {
        &.tool-nav-disabled {
            opacity:0.1;
            border:1px solid ${(props) => props.theme.$gold};
        }
        min-height:1100px;
        h4 {
            text-transform: uppercase;
            font-size: ${(props) => props.theme['$font-size-19']};
            font-family: ${(props) => props.theme['$font-family-sans-serif']};
            margin:0 0 15px 0;

        }
    }
    .tool-body {
        &.tool-body-disabled {
            opacity:0.2;
        }
        text-align:left;
        margin:0 0 15px 0;
        min-height:1100px;
        border:1px solid ${(props) => props.theme.$gold};
        padding:25px;
        h2 {
            font-size: ${(props) => props.theme['$font-size-22']};
            color: ${(props) => props.theme.$gold};
            font-family: ${(props) => props.theme['$font-family-sans-serif']};
            font-weight: 400 !important;
            margin:0 0 15px 0;
        }
        .tool-body-disclaimer {
            ${(props) => bp.up('lg', props.theme['$grid-breakpoints'], `
                margin-right:15%;
            `)}
    
        }
    }
`;

export default withTheme(Style);
